import React from "react";
import Header from "./Header/Header";
import Main from "./Main/Main";
import "./Home.css"

const Home = () => {
    return (
        <React.Fragment>
            <Header />
            <Main />
        </React.Fragment>
    )
}

export default Home;
